import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/twitch': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M40.1 32h397.9v274.2l-117 117h-87l-56.8 56.8h-60.2v-56.8h-107v-314.3zM397.9 286.1v-214h-321v280.9h90.3v56.8l56.8-56.8h107zM331 149v116.9h-40.1v-116.9h40.1zM224 149v116.9h-40.1v-116.9h40.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/twitch.js
// module id = 1062
// module chunks = 0